<!--
  - Copyright (c) 2019 LNBIG.com
  - All rights reserved.
  -->

<template>
  <v-card hover>
    <v-card-title>{{ nodeData.lndID.toUpperCase() }}</v-card-title>
    <a @click="openURI()">
      <lnbig-qr-code
        :value="`${nodeData.uri}`"
        :level="levelQrCode"
        :size="sizeQrCode"
        mode="Byte"
      ></lnbig-qr-code>
    </a>
    <v-card-actions>
      <v-btn
        text
        @click="copyPubKey"
      >
        PUBKEY
      </v-btn>
      <v-btn
        text
        @click="copyURI"
      >
        URI
      </v-btn>
      <template v-if="showInfo">
        <v-spacer/>
        <v-btn
          icon
          @click="show = !show"
        >
          <v-icon>
            {{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </v-btn>
      </template>
    </v-card-actions>
    <template v-if="showInfo">
      <v-slide-y-transition>
        <v-card-text
          v-show="show"
          :style="{ 'overflowWrap': 'break-word'}"
        >
          URI: {{ nodeData.uri }}<br>Pubkey: {{ nodeData.nodeID }}
        </v-card-text>
      </v-slide-y-transition>
    </template>
  </v-card>
</template>

<script>
import Vue from 'vue'
import QrCode from "@/components/Mixin/QrCode"

export default {
  props: {
    nodeData: {
      type: Object,
      required: true
    },
    showInfo: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  mixins: [QrCode],
  data: () => (
    {
      show: false,
    }
  ),
  methods: {
    copyPubKey: function () {
      this.$copyText(this.nodeData.nodeID).then(
        e => {
          if (this.$snackBar) {
            this.$snackBar.color = 'success'
            this.$snackBar.timeout = 1700
            this.$snackBar.text = 'PUBKEY was copied!'
            this.$snackBar.show = true
          }
        },
        e => {
          if (this.$snackBar) {
            this.$snackBar.color = 'error'
            this.$snackBar.timeout = 3000
            this.$snackBar.text = 'Copy error of PUBKEY!'
            this.$snackBar.show = true
          }
        }
      )
    },
    openURI: function () {
      window.open(`lightning:${this.nodeData.uri}`, "_blank")
    },
    copyURI: function () {
      this.$copyText(this.nodeData.uri).then(
        e => {
          if (this.$snackBar) {
            this.$snackBar.color = 'success'
            this.$snackBar.timeout = 1700
            this.$snackBar.text = 'URI was copied!'
            this.$snackBar.show = true
          }
        },
        e => {
          if (this.$snackBar) {
            this.$snackBar.color = 'error'
            this.$snackBar.timeout = 3000
            this.$snackBar.text = 'Copy error of URI!'
            this.$snackBar.show = true
          }
        }
      )
    }

  }
}
</script>
